var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.pageLoading,
          expression: "pageLoading",
        },
      ],
      staticClass: "divBox lucky-wheel-setting",
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "setting-form",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "168px",
            size: "small",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "section-card", attrs: { shadow: "never" } },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("配置规则")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "参与条件", prop: "participateCondition" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formData.participateCondition,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "participateCondition", $$v)
                        },
                        expression: "formData.participateCondition",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("购买商品并支付成功"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("用户完成指定条件后获得抽奖资格。"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "订单类型", prop: "orderTypes" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-360",
                      attrs: {
                        multiple: "",
                        filterable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.formData.orderTypes,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "orderTypes", $$v)
                        },
                        expression: "formData.orderTypes",
                      },
                    },
                    _vm._l(_vm.orderTypeOptions, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.value, value: item.key },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("请选择完成后可获得抽奖资格的订单类型。"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "抽奖次数到账", prop: "creditOrderStatus" } },
                [
                  _c(
                    "div",
                    { staticClass: "inline-row" },
                    [
                      _c("span", { staticClass: "inline-label" }, [
                        _vm._v("订单状态为"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticClass: "w-220",
                          attrs: { filterable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.formData.creditOrderStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "creditOrderStatus", $$v)
                            },
                            expression: "formData.creditOrderStatus",
                          },
                        },
                        _vm._l(_vm.creditStatusOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "buyJumpValue" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _vm._v("\n          链接名称\n          "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: { content: _vm.jumpLinkTip, placement: "top" },
                        },
                        [_c("i", { staticClass: "el-icon-question tip-icon" })]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("JumpNative", {
                    ref: "jumpNative",
                    staticClass: "jump-select",
                    on: { change: _vm.onJumpChange },
                    model: {
                      value: _vm.formData.buyJumpValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "buyJumpValue", $$v)
                      },
                      expression: "formData.buyJumpValue",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v("用于用户暂无抽奖资格时，引导用户完成参与条件。"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "抽奖次数限制", prop: "perOrderDrawTimes" } },
                [
                  _c(
                    "div",
                    { staticClass: "inline-row" },
                    [
                      _c("span", { staticClass: "inline-label" }, [
                        _vm._v("每人每单可抽奖次数"),
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "w-220",
                        attrs: { maxlength: "5", placeholder: "请输入" },
                        on: { input: _vm.onPerOrderDrawTimesInput },
                        model: {
                          value: _vm.formData.perOrderDrawTimes,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "perOrderDrawTimes", $$v)
                          },
                          expression: "formData.perOrderDrawTimes",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "每人可抽奖次数上限", prop: "maxDrawTimes" },
                },
                [
                  _c("el-input", {
                    staticClass: "w-220",
                    attrs: { maxlength: "5", placeholder: "请输入" },
                    on: { input: _vm.onMaxDrawTimesInput },
                    model: {
                      value: _vm.formData.maxDrawTimes,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "maxDrawTimes", $$v)
                      },
                      expression: "formData.maxDrawTimes",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-tip" }, [
                    _vm._v(
                      "用于控制活动期间单个用户累计可获得/使用的抽奖次数上限。"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "section-card", attrs: { shadow: "never" } },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("活动规则")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "规则说明", prop: "ruleContent" } },
                [
                  _c(
                    "div",
                    { staticClass: "rule-editor" },
                    [
                      _c("Tinymce", {
                        attrs: { height: 420, toolbar: _vm.tinymceToolbar },
                        model: {
                          value: _vm.formData.ruleContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "ruleContent", $$v)
                          },
                          expression: "formData.ruleContent",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "rule-count",
                          class: {
                            "is-error":
                              _vm.ruleCharCount > _vm.RULE_CONTENT_MAX,
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.ruleCharCount) +
                              "/" +
                              _vm._s(_vm.RULE_CONTENT_MAX)
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "section-card", attrs: { shadow: "never" } },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("页面装修")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "转盘背景图", prop: "wheelBackgroundImage" },
                },
                [
                  _c("div", { staticClass: "bg-upload" }, [
                    _vm.formData.wheelBackgroundImage
                      ? _c(
                          "div",
                          {
                            staticClass: "bg-preview",
                            on: { click: _vm.uploadBgImage },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: _vm.formData.wheelBackgroundImage,
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "el-icon-close bg-remove",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  _vm.formData.wheelBackgroundImage = ""
                                },
                              },
                            }),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "bg-upload-box",
                            on: { click: _vm.uploadBgImage },
                          },
                          [
                            _c("i", { staticClass: "el-icon-plus" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "bg-upload-main" }, [
                              _vm._v("上传主图"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "bg-upload-tip" }, [
                              _vm._v("支持格式：JPG、PNG"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "bg-upload-tip" }, [
                              _vm._v("图片大小：不超过2MB"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "bg-upload-tip" }, [
                              _vm._v("建议尺寸：750 × 750 px"),
                            ]),
                          ]
                        ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer-actions" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:activity:luckywheel:config"],
                      expression: "['admin:activity:luckywheel:config']",
                    },
                  ],
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.ruleSaving,
                  },
                  on: { click: _vm.handleSave },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }